import React, { FC } from 'react';
import Form from 'react-bootstrap/Form';

interface PropsType {
    id: string;
    value: string;
    handleOnChange: (e: string) => void;
    disabled?: boolean;
}

export const StringInput: FC<PropsType> = ({ id, value, handleOnChange, ...props }) => {
    return <Form.Control type="text"
                         id={id}
                         placeholder="Enter String"
                         onChange={e => handleOnChange(e.target.value)}
                         value={value}
                         disabled={props.disabled}
                         {...props} />;
};
